import {apiBase} from 'api/base.js';

const EcsTasksAPI = {
  execute: (params) => {
    return apiBase.request('/admin/ecs_tasks/execute', 'POST', params);
  }
};

export {EcsTasksAPI as ecsTasksAPI};
